import { render, staticRenderFns } from "./scene16.vue?vue&type=template&id=8556dc26&scoped=true&"
import script from "./scene16.vue?vue&type=script&lang=ts&"
export * from "./scene16.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556dc26",
  null
  
)

export default component.exports